module.exports = __webpack_public_path__ + "static/media/CSVicon.3aac07d3.svg";